import { createTheme } from "@mui/material/styles";

const defaultShadows = createTheme().shadows;

// "Soft cyber": sombras bajas de opacidad, sin glow en reposo.
// Solo se suavizan los primeros niveles (los que realmente se usan en Card/Paper/AppBar);
// el resto queda igual al default de MUI.
export const buildShadows = (mode) => {
  const shadows = [...defaultShadows];
  const shadowColor = mode === "dark" ? "0,0,0" : "20,21,31";
  const opacity = mode === "dark" ? [0.4, 0.45, 0.5, 0.55] : [0.08, 0.1, 0.12, 0.14];

  shadows[1] = `0px 1px 3px rgba(${shadowColor},${opacity[0]})`;
  shadows[2] = `0px 2px 6px rgba(${shadowColor},${opacity[1]})`;
  shadows[3] = `0px 4px 10px rgba(${shadowColor},${opacity[2]})`;
  shadows[4] = `0px 6px 14px rgba(${shadowColor},${opacity[3]})`;

  return shadows;
};
